module.exports = __webpack_public_path__ + "components/MapControl/svg/Amfiteatr.png?f0ca1719";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Amfiteatr.png
// module id = 1974
// module chunks = 0